import Vue from 'vue';
import '@/assets/scss/main.scss';
import 'froala-editor/js/froala_editor.pkgd.min';
import 'froala-editor/js/plugins/char_counter.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/js/plugins/code_beautifier.min';
import 'froala-editor/js/plugins/lists.min';
import 'froala-editor/js/plugins/url.min';
import 'froala-editor/js/plugins/word_paste.min';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/link.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import '../node_modules/vuetify/dist/vuetify.min.css';
import App from './App';
import router from './router';
import components from './components';
import directives from './directives';
import filters from './filters';
import plugins from './plugins';
import services from './services';
import store from './store';
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.use(components);
Vue.use(directives);
Vue.use(filters);
Vue.use(plugins);
Vue.use(services);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js